/* ============================================================
   cs-doc.js
   Turns loosely written page and policy text into designed blocks.
   Runs on regular pages (with cs-page-banner) and on /policies/*.

   Only the layout changes, never the words:
     bold line ending in ":"      -> numbered section card with a title
     "3-6 days (UPS Ground)"      -> delivery-time row
     list item that is one bold   -> sub-heading
     underlined text              -> mint highlight
     plain-text email address     -> mailto link
     line starting with "- "      -> sign-off
     empty lines / stray spaces   -> removed
   Content before the first heading becomes an intro card.
   ============================================================ */
(function () {
  var EMAIL = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;
  var TIME = /^(\d+\s*[-–]\s*\d+|\d+)\s*(business\s+)?days?\s*\((.+)\)\s*$/i;

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  function isEmpty(el) {
    return !text(el) && !el.querySelector('img, iframe, video, table, a[href]');
  }

  /* a block whose visible text is entirely bold */
  function isBoldLine(el) {
    var t = text(el);
    if (!t || t.length > 60) return false;
    var bold = Array.prototype.map.call(el.querySelectorAll('strong, b'), text).join(' ').replace(/\s+/g, ' ').trim();
    return bold === t;
  }

  function linkEmails(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      if (EMAIL.test(n.nodeValue) && !n.parentNode.closest('a')) nodes.push(n);
      EMAIL.lastIndex = 0;
    }
    nodes.forEach(function (node) {
      var span = document.createElement('span');
      span.innerHTML = node.nodeValue.replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; })
        .replace(EMAIL, '<a class="cs-doc__mail" href="mailto:$1">$1</a>');
      node.parentNode.replaceChild(span, node);
    });
  }

  function enhance(src) {
    if (src.dataset.csDoc) return;
    src.dataset.csDoc = '1';

    linkEmails(src);
    src.querySelectorAll('[style*="underline"], u').forEach(function (u) {
      u.removeAttribute('style'); u.classList.add('cs-doc__mark');
    });

    /* flatten: top-level blocks, empties dropped */
    var blocks = Array.prototype.filter.call(src.children, function (el) { return !isEmpty(el); });

    var doc = document.createElement('div');
    doc.className = 'cs-doc';
    var current = null, count = 0;

    function newSection(title) {
      count++;
      var sec = document.createElement('section');
      sec.className = 'cs-doc__sec';
      var head = document.createElement('header');
      head.className = 'cs-doc__head';
      head.innerHTML = '<span class="cs-doc__n">' + (count < 10 ? '0' : '') + count + '</span><h2 class="cs-doc__title"></h2>';
      head.querySelector('h2').textContent = title.replace(/:\s*$/, '');
      sec.appendChild(head);
      var body = document.createElement('div');
      body.className = 'cs-doc__body';
      sec.appendChild(body);
      doc.appendChild(sec);
      return body;
    }
    function intro() {
      if (current) return current;
      var sec = document.createElement('section');
      sec.className = 'cs-doc__sec cs-doc__sec--intro';
      var body = document.createElement('div');
      body.className = 'cs-doc__body';
      sec.appendChild(body);
      doc.appendChild(sec);
      current = body;
      return body;
    }

    blocks.forEach(function (el) {
      var t = text(el);
      var tag = el.tagName;

      /* section heading: real headings, bold "Title:" lines, or any short "Title:" line */
      if ((/^H[1-6]$/.test(tag)) || (tag !== 'UL' && tag !== 'OL' && /:\s*$/.test(t) && (isBoldLine(el) || t.length <= 40))) {
        current = newSection(t);
        return;
      }

      /* "<strong>Title</strong><br>text" in one paragraph: split into heading + text */
      var lead = el.firstElementChild;
      if (lead && /^(STRONG|B)$/.test(lead.tagName) && text(lead).length <= 40 && lead.nextElementSibling && lead.nextElementSibling.tagName === 'BR'
          && !(el.firstChild && el.firstChild.nodeType === 3 && el.firstChild.nodeValue.trim())) {
        current = newSection(text(lead));
        var rest = el.cloneNode(true);
        rest.removeChild(rest.firstElementChild);
        if (rest.firstElementChild && rest.firstElementChild.tagName === 'BR') rest.removeChild(rest.firstElementChild);
        var rp = document.createElement('p');
        rp.innerHTML = rest.innerHTML;
        current.appendChild(rp);
        return;
      }

      /* *WRAPPED IN ASTERISKS*: a callout */
      if (/^\*[^*]+\*/.test(t)) {
        var call = document.createElement('p');
        call.className = 'cs-doc__callout';
        call.textContent = t.replace(/\*/g, '').replace(/\s{2,}/g, ' ').trim();
        intro().appendChild(call);
        return;
      }

      /* "* item" lines: real bullets */
      if (/^\*\s+\S/.test(t)) {
        var body = intro();
        var list = body.lastElementChild && body.lastElementChild.classList.contains('cs-doc__list') ? body.lastElementChild : null;
        if (!list) { list = document.createElement('ul'); list.className = 'cs-doc__list'; body.appendChild(list); }
        var li = document.createElement('li');
        li.innerHTML = el.innerHTML.replace(/^\s*\*\s+/, '');
        list.appendChild(li);
        return;
      }

      /* list made of one bold item: a sub-heading */
      if ((tag === 'UL' || tag === 'OL') && el.children.length === 1 && isBoldLine(el.children[0])) {
        var sub = document.createElement('h3');
        sub.className = 'cs-doc__sub';
        sub.textContent = text(el.children[0]).replace(/:\s*$/, '');
        intro().appendChild(sub);
        return;
      }

      /* delivery time row */
      var m = t.match(TIME);
      if (m) {
        var row = document.createElement('div');
        row.className = 'cs-doc__row';
        row.innerHTML = '<b></b><span></span>';
        row.querySelector('b').textContent = m[1].replace(/\s*[-–]\s*/, '–') + ' ' + (m[2] || '') + 'days';
        row.querySelector('span').textContent = m[3];
        intro().appendChild(row);
        return;
      }

      /* sign-off: "- Casa Soles" */
      if (/^[-–]\s+\S/.test(t) && t.length < 40) {
        var sign = document.createElement('p');
        sign.className = 'cs-doc__sign';
        sign.textContent = t.replace(/^[-–]\s+/, '');
        intro().appendChild(sign);
        return;
      }

      /* anything else keeps its own markup, tidied */
      var keep = el.cloneNode(true);
      if (tag === 'DIV') {
        var p = document.createElement('p');
        p.innerHTML = keep.innerHTML;
        keep = p;
      }
      keep.querySelectorAll('div:empty, p:empty, span:empty').forEach(function (e) { e.remove(); });
      /* drop the hand-typed indent: leading spaces on the first text, even inside <strong> */
      var tw = document.createTreeWalker(keep, NodeFilter.SHOW_TEXT, null), first;
      while ((first = tw.nextNode())) {
        first.nodeValue = first.nodeValue.replace(/^[\s\u00a0]+/, '');
        if (first.nodeValue) break;
      }
      intro().appendChild(keep);
    });

    /* group consecutive delivery rows into one table-like card */
    doc.querySelectorAll('.cs-doc__body').forEach(function (body) {
      var group = null;
      Array.prototype.slice.call(body.children).forEach(function (el) {
        if (el.classList.contains('cs-doc__row')) {
          if (!group) { group = document.createElement('div'); group.className = 'cs-doc__rows'; body.insertBefore(group, el); }
          group.appendChild(el);
        } else { group = null; }
      });
    });

    if (!doc.children.length) return;
    src.innerHTML = '';
    src.appendChild(doc);
    src.classList.add('cs-doc-host');
  }

  function boot() {
    document.querySelectorAll('.shopify-policy__body .rte, .shopify-policy__body, body:has(.cs-page-banner) .main-page-title ~ .rte, .cs-contact__rte')
      .forEach(function (el) {
        /* policies sometimes have an .rte inside the body, only enhance the innermost */
        if (el.querySelector('.rte')) return;
        enhance(el);
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
